import { render, staticRenderFns } from "./AstroCalendar.vue?vue&type=template&id=71b495b9&"
import script from "./AstroCalendar.vue?vue&type=script&lang=js&"
export * from "./AstroCalendar.vue?vue&type=script&lang=js&"
import style0 from "./AstroCalendar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71b495b9')) {
      api.createRecord('71b495b9', component.options)
    } else {
      api.reload('71b495b9', component.options)
    }
    module.hot.accept("./AstroCalendar.vue?vue&type=template&id=71b495b9&", function () {
      api.rerender('71b495b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/共時曆/AstroCalendar.vue"
export default component.exports